export class UpdateTipoFolioRequest {
    public id: number= 0; 
    public descripcion : string="";    
}